import { GET_POTENTIAL_COUNT } from '../Actions/actionTypes';
let initial={
  results:{
    Count:0,
    countReceived:false
  }
};

export default (state=initial,action)=>{
  switch(action.type){
      case GET_POTENTIAL_COUNT:
        return {...action.payload,results:{Count:action.payload.results.Count,countReceived:true}};
      case "REFETCH_COUNT":
          return {...state,results:{Count:0,countReceived:false}};
      default:
        return state;
  }
}